import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import HttpBackend from 'i18next-http-backend'
import i18n from 'i18next'

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(HttpBackend)
  .init({
    load: 'languageOnly',
    ns: ['enums', 'app'],
    fallbackLng: 'es',
    debug: __DEV__,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    interpolation: {
      escapeValue: false, // React escapes by default
    },
  })
